// Swap these with the live store URLs when available — badges become active automatically.
export const STORE_LINKS = {
  apple: "",
  google: "",
};

export default function StoreBadges({ dark = true, testidPrefix = "store" }) {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
      <Badge
        testid={`${testidPrefix}-app-store`}
        href={STORE_LINKS.apple}
        label="Download on the"
        store="App Store"
        icon={<path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.61-.75 1.04-1.8 0.92-2.87-.93.04-2.02.63-2.67 1.39-.58.67-1.09 1.74-.96 2.78 1.04.08 2.08-.54 2.71-1.3" />}
        dark={dark}
      />
      <Badge
        testid={`${testidPrefix}-google-play`}
        href={STORE_LINKS.google}
        label="Get it on"
        store="Google Play"
        icon={<path d="M3.609 1.814L13.792 12 3.61 22.186a2.235 2.235 0 0 1-.22-.988V2.802c0-.368.08-.707.219-.988zm11.236 11.238l2.583 2.583-11.75 6.778 9.167-9.361zm0-2.104L5.678 1.587l11.75 6.778-2.583 2.583zm1.447 1.052l3.774 2.176c.866.5.866 1.316 0 1.816l-3.774 2.176-2.148-2.148 2.148-2.22z" />}
        dark={dark}
      />
    </div>
  );
}

function Badge({ testid, href, label, store, icon, dark }) {
  const live = Boolean(href);
  return (
    <a
      href={live ? href : "#get-app"}
      {...(live ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-3 px-6 py-3.5 rounded-2xl text-sm font-semibold transition-colors ${
        dark
          ? "bg-stone-900 text-white hover:bg-stone-800 shadow-md"
          : "bg-white text-stone-900 border border-stone-200 hover:border-stone-300 shadow-sm"
      }`}
    >
      <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" aria-hidden="true">{icon}</svg>
      <div className="text-left leading-tight">
        <div className={`text-[10px] uppercase tracking-wider ${dark ? "text-stone-400" : "text-stone-500"}`}>{label}</div>
        <div className="text-sm font-bold">
          {store}
          {!live && <span className="text-[10px] font-normal text-emerald-500 ml-1">(Coming Soon)</span>}
        </div>
      </div>
    </a>
  );
}
